export default function SoutheastAsiaCountry() {
  return (
    <div className="min-h-screen bg-white">
      {/* Hero Section */}
      <section className="bg-gradient-to-br from-teal-50 to-blue-50 py-20">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <h1 className="text-4xl md:text-5xl font-bold text-navy-900 mb-4">
            Southeast Asia Nursing Pathways
          </h1>
          <p className="text-xl text-slate-600">
            Philippines • Indonesia • Malaysia • Thailand • Vietnam
          </p>
        </div>
      </section>

      {/* Content Section */}
      <section className="py-16 px-6">
        <div className="max-w-4xl mx-auto space-y-12">
          {/* Intro */}
          <div className="prose prose-lg max-w-none">
            <p className="text-slate-700 leading-relaxed">
              Strong track record in the Philippines and across Southeast Asia. Choose your route and follow our step-by-step guides.
            </p>
          </div>

          {/* Popular Routes */}
          <div>
            <h2 className="text-2xl font-bold text-navy mb-4">Popular routes</h2>
            <ul className="space-y-2 text-slate-700">
              <li className="flex items-start">
                <span className="text-teal-600 mr-2">•</span>
                <span>USA: NCLEX → CGFNS/VisaScreen → Recruiter match</span>
              </li>
              <li className="flex items-start">
                <span className="text-teal-600 mr-2">•</span>
                <span>UK/Ireland: NMC → CBT → OSCE → Trust placement</span>
              </li>
              <li className="flex items-start">
                <span className="text-teal-600 mr-2">•</span>
                <span>GCC: Prometric/HAAD/DHA → Dataflow/TrueProfile → Hospital contract</span>
              </li>
            </ul>
          </div>

          {/* By Country Accordion */}
          <div>
            <h2 className="text-2xl font-bold text-navy mb-4">By country (quick guidance)</h2>
            <div className="space-y-3">
              <details className="group bg-white border border-slate-200 rounded-lg overflow-hidden">
                <summary className="cursor-pointer p-4 font-semibold text-navy hover:bg-slate-50 transition-colors flex justify-between items-center">
                  Philippines
                  <span className="text-teal-600 group-open:rotate-180 transition-transform">▼</span>
                </summary>
                <div className="p-4 pt-0 text-slate-700 space-y-2">
                  <p><strong>NCLEX:</strong> Large passer base; strong demand for USA.</p>
                  <p><strong>UK/GCC:</strong> CBT/OSCE and Dataflow pathways are well-established.</p>
                </div>
              </details>
              <details className="group bg-white border border-slate-200 rounded-lg overflow-hidden">
                <summary className="cursor-pointer p-4 font-semibold text-navy hover:bg-slate-50 transition-colors flex justify-between items-center">
                  Indonesia • Malaysia • Thailand • Vietnam
                  <span className="text-teal-600 group-open:rotate-180 transition-transform">▼</span>
                </summary>
                <div className="p-4 pt-0 text-slate-700 space-y-2">
                  <p><strong>Focus:</strong> English proficiency and document readiness.</p>
                  <p><strong>Tip:</strong> Keep Good Standing and immunization records up to date.</p>
                </div>
              </details>
            </div>
          </div>

          {/* Typical Timeline */}
          <div>
            <h2 className="text-2xl font-bold text-navy mb-4">Typical timeline</h2>
            <div className="space-y-4">
              <div className="flex items-start gap-4">
                <div className="flex-shrink-0 w-24 font-semibold text-teal-600">Month 1–2</div>
                <div className="text-slate-700">Profile & document prep; begin NCLEX/English</div>
              </div>
              <div className="flex items-start gap-4">
                <div className="flex-shrink-0 w-24 font-semibold text-teal-600">Month 3–4</div>
                <div className="text-slate-700">Exam + primary source verifications</div>
              </div>
              <div className="flex items-start gap-4">
                <div className="flex-shrink-0 w-24 font-semibold text-teal-600">Month 5–6</div>
                <div className="text-slate-700">Verification finished; enable Recruiter Visibility</div>
              </div>
              <div className="flex items-start gap-4">
                <div className="flex-shrink-0 w-24 font-semibold text-teal-600">Placement</div>
                <div className="text-slate-700">Interviews and onboarding</div>
              </div>
            </div>
          </div>

          {/* FAQ */}
          <div>
            <h2 className="text-2xl font-bold text-navy mb-4">Frequently Asked Questions</h2>
            <div className="space-y-3">
              <details className="group bg-white border border-slate-200 rounded-lg overflow-hidden">
                <summary className="cursor-pointer p-4 font-semibold text-navy hover:bg-slate-50 transition-colors flex justify-between items-center">
                  Can I switch destinations later?
                  <span className="text-teal-600 group-open:rotate-180 transition-transform">▼</span>
                </summary>
                <div className="p-4 pt-0 text-slate-700">
                  Yes. Your profile and documents carry over; you may add exams as needed.
                </div>
              </details>
              <details className="group bg-white border border-slate-200 rounded-lg overflow-hidden">
                <summary className="cursor-pointer p-4 font-semibold text-navy hover:bg-slate-50 transition-colors flex justify-between items-center">
                  Do I need IELTS/OET?
                  <span className="text-teal-600 group-open:rotate-180 transition-transform">▼</span>
                </summary>
                <div className="p-4 pt-0 text-slate-700">
                  Depends on destination and employer. Our guides break this down per route.
                </div>
              </details>
            </div>
          </div>

          {/* CTA Buttons */}
          <div className="bg-teal-50 rounded-lg p-8 text-center">
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a
                href="/signup"
                className="px-8 py-3 bg-teal-600 text-white font-semibold rounded-lg hover:bg-teal-700 transition-colors text-center"
              >
                Register Free
              </a>
              <a
                href="/resources"
                className="px-8 py-3 border-2 border-teal-600 text-teal-600 font-semibold rounded-lg hover:bg-teal-50 transition-colors text-center"
              >
                See Resources
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
